<script lang="ts">
	let { overline, title, dark = false } = $props();
</script>

<div class="mb-12 flex flex-col items-center gap-6">
	<p class={[dark ? 'text-yellow' : 'text-blue-light', 'over-line-2 text-center']}>{overline}</p>

	<div class={[dark ? 'bg-white' : 'bg-gray', 'h-12 w-px']}></div>

	<h2 class={[dark ? 'text-white' : 'text-blue', 'heading-3 text-center']}>{title}</h2>
</div>